import { CommonModule } from '@angular/common'
import { Injector, NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  CmsConfig,
  ContextServiceMap,
  provideDefaultConfig,
  SiteContextModule,
} from '@spartacus/core'
import { LanguageCurrencyComponent } from './language-currency.component'
import { SiteContextComponentService } from './site-context-component.service'
import { SiteContextSelectorComponent } from './site-context-selector.component'
import { IconModule, CmsComponentData } from '@spartacus/storefront'
import { ClickOutsideModule } from '../../directive/clickOutside/click-outside.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SiteContextModule,
    IconModule,
    ClickOutsideModule,
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        CMSSiteContextComponent: {
          component: SiteContextSelectorComponent,
          providers: [
            {
              provide: SiteContextComponentService,
              useClass: SiteContextComponentService,
              deps: [CmsComponentData, ContextServiceMap, Injector],
            },
          ],
        },
        LanguageCurrencyComponent: {
          component: LanguageCurrencyComponent,
        },
      },
    } as CmsConfig),
    SiteContextComponentService,
  ],
  declarations: [SiteContextSelectorComponent, LanguageCurrencyComponent],
  exports: [SiteContextSelectorComponent, LanguageCurrencyComponent],
})
export class SiteContextSelectorModule {}
